import React, { useState } from "react";
import HoverIconButton from "components/HoverIconButton";
import classnames from "classnames";
import get from "lodash/get";
import { setEditorFocus } from "utils/builder";
import { useFormikContext } from "formik";
import { usePageBuilderContext } from "utils/context";
import Analytics, { CLICK_MENU_NAV_LIST } from "utils/analytics";
const NO_OP = () => {};

const MenuListItem = ({
  label,
  description,
  focus,
  action,
  disabled,
  onClick
}) => {
  const { setValues, values } = useFormikContext();
  const [hover, setHover] = useState(false);

  const pageContext = usePageBuilderContext();
  const tracking = pageContext ? pageContext.tracking : {};

  const containerProps = {
    className: classnames(
      "flex flex-column items-center justify-between ph3 bb hairline-1 bg-white bh--inset",
      {
        "bg-content--secondary": hover,
        "bg-white": !hover,
        "pv3": !action,
        "o-50": disabled,
        "pointer": !disabled
      }
    ),
    onMouseEnter: () => !disabled && !hover && setHover(true),
    onMouseLeave: () => !disabled && hover && setHover(false)
  };
  const labelProps = {
    className: classnames("fw6 f5 w-100", {
      "pl2 pv1": action
    })
  };
  const descriptionProps = {
    className: classnames("f6 w-100 lh-copy pt1", {
      "pl2 pt3": action
    })
  };
  const navIconProps = {
    type: "right",
    size: 18,
    customClasses: {
      button:
        "ma0 items-center flex pa1 dib items-center justify-center bn br1 panel--action relative bg-white bg-content--secondary bg-content--hover"
    }
  };
  const setFocus = () => {
    Analytics.track(CLICK_MENU_NAV_LIST, {
      value: get(focus, "[0].value")
    });
    setEditorFocus({
      values,
      setValues,
      focus
    })();
  };
  let labelContent;
  let descriptionContent;
  let clickHandler;
  if (disabled) {
    clickHandler = NO_OP;
  } else if (onClick) {
    clickHandler = onClick;
  } else {
    clickHandler = setFocus;
  }

  if (!action) {
    containerProps.onClick = clickHandler;
    labelContent = <div {...labelProps}>{label}</div>;
    if (description) {
      descriptionContent = <div {...descriptionProps}>{description}</div>;
    }
  } else {
    labelProps.onClick = clickHandler;
    navIconProps.onClick = clickHandler;
    const deadZoneClick = (
      <div onClick={setFocus} className="flex w-100 h-auto pointer o-0">
        {`_`}
      </div>
    );
    labelContent = (
      <div className="flex flex-column h-auto w-100">
        {deadZoneClick}
        <div {...labelProps}>{label}</div>
        {deadZoneClick}
      </div>
    );
    if (description) {
      descriptionContent = (
        <div className="flex flex-column h-auto w-100">
          {deadZoneClick}
          <div {...descriptionProps}>{description}</div>
          {deadZoneClick}
        </div>
      );
    }
  }

  return (
    <div {...containerProps}>
      <div className="flex flex-row w-100 justify-between items-center">
        {action && <HoverIconButton {...action} />}
        {labelContent}
        <HoverIconButton {...navIconProps} />
      </div>
      {descriptionContent}
    </div>
  );
};

const MenuNavList = ({ config }) => {
  return config.map((itemConfig, itemConfigIx) => {
    if (itemConfig.items) {
      return (
        <div className="dib" key={itemConfigIx}>
          <div className="f6 fw6 ph3 pv2 bb hairline-1 bg-content--secondary bh--inset">
            {itemConfig.label}
          </div>
          {itemConfig.items.map((subItemConfig, subItemConfigIx) => (
            <MenuListItem key={subItemConfigIx} {...subItemConfig} />
          ))}
        </div>
      );
    } else {
      return <MenuListItem key={itemConfigIx} {...itemConfig} />;
    }
  });
};

export default MenuNavList;
